import {
    getAxiosFulfilledState,
    getPendingState,
    getRejectedState,
    getSettingsState,
    resetState,
} from '../helpers/reducerHelper'
import { IReduxAction } from './index'
import { DataPromise, getDataEmptyState } from '../context/AxiosContext'
import { TimeAction } from '../config/registration/timeConfig'
import { ActionType } from 'redux-promise-middleware'
import { ITimeListSettings } from '../components/List/Time/TimeList'
import { TimeOverviewDto } from '../config/registrationConfig'
import { DateTime } from 'luxon'

export interface ITimeState {
    overview: DataPromise<TimeOverviewDto[], ITimeListSettings>
}

const defaultState: ITimeState = {
    overview: getDataEmptyState<TimeOverviewDto[], ITimeListSettings>({
        filter: {
            from: DateTime.local().toISODate(),
            to: DateTime.local().toISODate(),
            users: null,
            isBilled: null,
        },
    }),
}

export default function reducer(state: ITimeState = defaultState, action: IReduxAction): ITimeState {
    switch (action.type) {
        case TimeAction.OverviewSettings: {
            return getSettingsState(state, action, 'overview')
        }
        case `${TimeAction.GetOverview}_${ActionType.Pending}`: {
            return getPendingState(state, 'overview')
        }
        case `${TimeAction.GetOverview}_${ActionType.Rejected}`: {
            return getRejectedState(state, action, 'overview')
        }
        case `${TimeAction.GetOverview}_${ActionType.Fulfilled}`: {
            return getAxiosFulfilledState(state, action, 'overview')
        }
        case `${TimeAction.Add}_${ActionType.Fulfilled}`:
        case `${TimeAction.Update}_${ActionType.Fulfilled}`:
        case `${TimeAction.Delete}_${ActionType.Fulfilled}`:
        case TimeAction.ResetOverview: {
            // Reset the state to force other components to update the data.
            return resetState(state, { overview: null })
        }
    }

    return state
}
